import useIsMobileView from '~/hooks/use-is-mobile-view';
import useMediaQuery from '~/hooks/use-media-query';
import { deviceMedia } from '~/styled';

const useViewType = () => {
  return {
    mobileView: useIsMobileView(),
    tabletView: useMediaQuery(deviceMedia.between('s', 'xl')),
    smallTabView: useMediaQuery(deviceMedia.between('s', 'm')),
  };
};

export { useViewType };
